import { useCreateGenericEventMutation } from "~graphql/generated/graphql"

export function useCreateGenericEvent() {
    const [createGenericEvent] = useCreateGenericEventMutation()

    const createEvent = (
        eventType: string,
        metadata: Record<string, unknown>
    ) => {
        return createGenericEvent({
            variables: {
                data: { event_type: eventType, metadata },
            },
        })
    }

    return { createEvent }
}
